// bkp 
//const baseOT=[47.88,95.76,136.47],baseFull=[47.88,95.76,143.64],subDisc=[0.10,0.10,0.12];

const productPrice = parseFloat(
  $(".dg.custom-bundle").attr("price").replace("$", "")
);

const baseOT = [
  productPrice,
  productPrice * 2,
  productPrice * 2.85
];

const baseFull = [
  productPrice,
  productPrice * 2,
  //productPrice * 3
  126.69
];

const subDisc=[0.10,0.10,0];


//const baseOT=[47.88,95.76,136.47],baseFull=[47.88,95.76,126.69],subDisc=[0.10,0.10,0];

const pbOT=['$3.99/bar','$3.99/bar','$3.79/bar'],pbSub=['$3.59/bar','$3.59/bar','$3.52/bar'];
let size=1,pType='ot',choc=0,cinn=0;

function selSize(i,el){
document.querySelectorAll('.size-card').forEach(c=>c.classList.remove('active'));
el.classList.add('active'); size=i; choc=0; cinn=0;
//document.getElementById('single-flavor').style.display=i===0?'block':'none';
//document.getElementById('multi-flavor').style.display=i>0?'block':'none';
//document.getElementById('total-num').textContent=i+1;
//updateFlavor(); 
updatePrices(); updateCTA();
}

function adj(f,d){
const total=size+1,alloc=choc+cinn;
if(f==='choc'){if(d>0&&alloc>=total)return;choc=Math.max(0,choc+d);}
else{if(d>0&&alloc>=total)return;cinn=Math.max(0,cinn+d);}
//updateFlavor(); 
updateCTA();
}

// function updateFlavor(){
// const total=size+1,alloc=choc+cinn;
// document.getElementById('cv').textContent=choc;
// document.getElementById('nv').textContent=cinn;
// document.getElementById('alloc-num').textContent=alloc;
// document.getElementById('prog').style.width=(alloc/total*100)+'%';
// document.getElementById('cm').disabled=choc===0;
// document.getElementById('nm').disabled=cinn===0;
// document.getElementById('cp').disabled=alloc>=total;
// document.getElementById('np').disabled=alloc>=total;
// }

function setType(t,el){
document.querySelectorAll('.purch-row').forEach(r=>r.classList.remove('active'));
el.classList.add('active'); pType=t;
document.getElementById('freq-sec').style.display=t==='sub'?'block':'none';
updatePrices(); updateCTA();
}

function updatePrices(){
const s=pType==='sub';
document.querySelectorAll('.sz-disc').forEach(d=>d.classList.toggle('show',s));
for(let i=0;i<3;i++){
    document.getElementById('p'+i).textContent='$'+(s?baseFull[i]*(1-subDisc[i]):baseOT[i]).toFixed(2);
    document.getElementById('pb'+i).textContent=s?pbSub[i]:pbOT[i];
}
document.getElementById('once-p').textContent='$'+baseOT[size].toFixed(2);
document.getElementById('sub-orig').textContent='$'+baseFull[size].toFixed(2);
document.getElementById('sub-p').textContent='$'+(baseFull[size]*(1-subDisc[size])).toFixed(2);
}

function updateCTA(){
const total=size+1,ready=size===0||(choc+cinn)===total,isSub=pType==='sub';
const price=isSub?baseFull[size]*(1-subDisc[size]):baseOT[size];
const btn=document.getElementById('cta');
//btn.disabled=!ready;
//if(!ready){btn.className='cta sub';btn.textContent='Select your flavors to continue';}
if(isSub){btn.className='cta';btn.textContent='Subscribe — $'+price.toFixed(2);}
else{btn.className='cta';btn.textContent='Add to Cart — $'+price.toFixed(2);}
}

updatePrices(); updateCTA();

$(".size-card.active").trigger("click");
$(".purch-row.subscription").click(function(){
   $(".sz-discount").show();
});
$(".purch-row.one-time").click(function(){
   $(".sz-discount").hide();
});

$('button#cta').click(function(e){
    var qty = $(".size-card.active").attr("size");
    var pid = $(".dg-select.variants option:selected ").attr("pid");
    var sectionId = $(".custom-bundle").attr("id");
    var box = $(".size-card.active").index();
    var selling_plan = $(".purch-row.subscription").hasClass("active")
        ? $(".plan_selection.active").val() : null;

    var items = [];
    if(qty == 1){
        items.push({
            id: pid,
            quantity: qty,
            selling_plan: selling_plan
        });
    }
    else{
        $('.flavor-selector .flavor-row').each(function() {
            var row = $(this);
            var quantity = parseInt(row.data('quantity')) || 0;
            var pid = row.attr('pid');
            if (quantity > 0 && pid) {
                var item = {
                    id: parseInt(pid),
                    quantity: quantity,
                    selling_plan: selling_plan
                };
                items.push(item);
            }
        });
        //console.log('Cart items:', items);
        var totalQuantity = 0;
        $.each(items, function(index, item) {
            totalQuantity += item.quantity;
        });

        if (totalQuantity != qty) {
            if(!$('.flavor-error').length){
                $("<p class='flavor-error'>Select correct quantity</p>").insertAfter(".flavor-selector__list");
            }
            return;
        }

    }
    // if(box == 0){
    //     items.push({
    //         id: $(".dg-select.variants").val(),
    //         quantity: 1,
    //         selling_plan: selling_plan
    //     });

    // } else {
    //     var chocQty = parseInt($("#cv").text()) || 0;
    //     var cinnQty = parseInt($("#nv").text()) || 0;
    //     var chocVariantId = $('#cv').attr("v_id");
    //     var cinnVariantId = $('#nv').attr("v_id");
    //     if(chocQty > 0){
    //         items.push({
    //             id: chocVariantId,
    //             quantity: chocQty,
    //             selling_plan: selling_plan
    //         });
    //     }
    //     if(cinnQty > 0){
    //         items.push({
    //             id: cinnVariantId,
    //             quantity: cinnQty,
    //             selling_plan: selling_plan
    //         });
    //     }
    // }
    if(!items.length){
        alert('Please select a quantity');
        return;
    }
    const payload = {
        items: items,
        sections: "cart-items,cart-footer,cart-item-count,cart-live-region,cart-recommendations",
        sections_url: window.location.pathname,
        "section-id": sectionId
    };
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(payload),
        contentType: 'application/json',
        dataType: 'json',
        success: function(data){
            if(data.sections){
                $('#CartItems').html(data.sections['cart-items']);
                $('.cart-footer').html(data.sections['cart-footer']);
                $('#CartButton .cart_count').html(data.sections['cart-item-count']);
                $(".cart_count").show();
                $("#CartButton").trigger("click");
                $(".flavor-error").remove();
            }
            document.dispatchEvent(
                new CustomEvent('theme:cart:update')
            );
        },
        error: function(err){
            console.log(err);
        }
    });

});

//show hide variant desc
$('.dg-select.variants').on('change', function () {
    window.location.href = $(this).val();
});


$(".size-card").click(function(){
    var index = $(this).index(); 
    if(index == 0){
        $(".flavor-selector").hide();
        $("#single-flavor").show();
    }
    else{
        $(".flavor-selector").show();
        $("#single-flavor").hide();
    }
    setTimeout(function () {
        var price = $("#once-p").text();
        $("#sub-orig").text(price);
    }, 50);

});


$(document).ready(function () {
    var previousUrl = document.referrer;
    var urlParams = new URLSearchParams(window.location.search);
    var fbclid = urlParams.get('fbclid');

    var fromFacebook =
        previousUrl.includes('facebook.com') ||
        previousUrl.includes('l.facebook.com') ||
        fbclid !== null;

    if (fromFacebook) {
        $(".cta").on("click", function () {
            setTimeout(function () {
            $(".free-shipping-text").text(
                "Free shipping unlocked on your first order 🎉"
            );
            }, 1500);
        });
    }
    $('.jdgm-preview-badge').on('click', function () {
        $('html, body').animate({
            scrollTop: $('.jdgm-widget-revamp').offset().top
        }, 800);
    });


    // quantity selector
    var selectedBoxes = parseInt($('.size-card.active').attr('size')) || 1;
    $('.size-card').on('click', function () {
        selectedBoxes = parseInt($(this).attr('size')) || 1;
        // Reset all flavor quantities
        $('.flavor-selector .flavor-row').each(function () {
            var row = $(this);
            row.data('quantity', 0);
            row.find('.quantity-value').text(0);
        });
        updateQuantities();
    });


    // Flavor selection
    $('.flavor-selector .flavor-row').each(function () {
        var row = $(this);
        var minusButton = row.find('.quantity-minus');
        var plusButton = row.find('.quantity-plus');
        var quantityElement = row.find('.quantity-value');
        row.data('quantity', 0);
      
        plusButton.on('click', function () {
            var quantity = parseInt(row.data('quantity')) || 0;
            var totalQuantity = getTotalQuantity();
            if (totalQuantity < selectedBoxes) {
                quantity++;
                row.data('quantity', quantity);
                updateQuantities();
            }
        });
    
        minusButton.on('click', function () {
            var quantity = parseInt(row.data('quantity')) || 0;
            if (quantity > 0) {
                quantity--;
                row.data('quantity', quantity);
                updateQuantities();
            }
        });
    });


    // Get total flavor quantity
    function getTotalQuantity() {
        var total = 0;
        $('.flavor-selector .flavor-row').each(function () {
            total += parseInt($(this).data('quantity')) || 0;
        });
        return total;
    }

    // Update all flavor buttons/counts
    function updateQuantities() {
        var totalQuantity = getTotalQuantity();
        $('.flavor-selector .flavor-row').each(function () {
            var row = $(this);
            var quantity = parseInt(row.data('quantity')) || 0;
            var minusButton = row.find('.quantity-minus');
            var plusButton = row.find('.quantity-plus');
            var quantityElement = row.find('.quantity-value');

            // Update number
            quantityElement.text(quantity);

            // Minus button
            if (quantity <= 0) {
                minusButton.prop('disabled', true);
                minusButton.css('opacity', '0.65');
            } else {
                minusButton.prop('disabled', false);
                minusButton.css('opacity', '1');
            }

            // Plus button
            if (totalQuantity >= selectedBoxes) {
                plusButton.prop('disabled', true);
                plusButton.css('opacity', '0.65');
            } else {
                plusButton.prop('disabled', false);
                plusButton.css('opacity', '1');
            }
        });
    }

    updateQuantities();
});